export const slugifyForFilename = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const normalizeFileName = (file: File): File => {
  const allowedCharsRegex = /[^a-zA-Z0-9._-]/g;

  const originalName = file.name;
  const lastDotIndex = originalName.lastIndexOf('.');
  const name = lastDotIndex !== -1 ? originalName.slice(0, lastDotIndex) : originalName;

  const extension = lastDotIndex !== -1 ? originalName.slice(lastDotIndex) : '';

  const cleanedName = name.replace(/\s+/g, '_').replace(allowedCharsRegex, '');

  const normalizedName = cleanedName + extension;

  return new File([file], normalizedName, {
    type: file.type,
    lastModified: file.lastModified,
  });
};
